import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VClickOutside from "v-click-outside";
import VScrollLock from "v-scroll-lock";
import { VTooltip } from "v-tooltip";

Vue.use(VClickOutside);
Vue.use(VScrollLock)

VTooltip.options.defaultClass = "tooltip"

Vue.directive("tooltip", VTooltip)



import { library } from "@fortawesome/fontawesome-svg-core";
import { faTree as tree, faCalendarAlt as calendar, faGift as gift } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import BouncingLoader from "@/components/Loader.vue"

Vue.config.productionTip = false;

library.add(
  tree,
  calendar,
  gift
);

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("BouncingLoader", BouncingLoader)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
